export default __webpack_public_path__ + "static/media/Facebook.6ed6887f.png";